export const roles = {
	OPERATOR: 'Оператор',
	PTS: 'ПТС',
	FACTORY: 'Завод',
	// FACTORY_NRS: 'Завод НРС',
	FISHERMAN: 'Добытчик',
	BOX_CONTROLLER: 'Контроллер',
	WEB_RECEPTION: 'Приемщик в вебе'
}

export const rolesAuth = {
	ADMIN: null,
	OPERATOR: null,
	PTS: null,
	FACTORY: null,
	WEB_RECEPTION: null
}
